import DescriptionOutlined from "@mui/icons-material/DescriptionOutlined";
import GridOnOutlined from "@mui/icons-material/GridOnOutlined";
import ImageOutlined from "@mui/icons-material/ImageOutlined";
import InsertDriveFileOutlined from "@mui/icons-material/InsertDriveFileOutlined";
import PictureAsPdfOutlined from "@mui/icons-material/PictureAsPdfOutlined";

export const IMAGE_EXTENSIONS = [
  "png",
  "jpg",
  "jpeg",
  "gif",
  "webp",
  "bmp",
  "svg",
] as const;

const DOCUMENT_EXTENSIONS = ["pdf", "xlsx", "csv", "docx"] as const;

export const PREVIEWABLE_EXTENSIONS = [
  ...DOCUMENT_EXTENSIONS,
  ...IMAGE_EXTENSIONS,
] as const;

type PreviewExtension = (typeof PREVIEWABLE_EXTENSIONS)[number];

export function isPreviewable(ext: string | null | undefined): boolean {
  if (!ext) return false;
  return PREVIEWABLE_EXTENSIONS.includes(
    ext.toLowerCase() as PreviewExtension
  );
}

export function isImage(ext: string | null | undefined): boolean {
  if (!ext) return false;
  return (IMAGE_EXTENSIONS as readonly string[]).includes(ext.toLowerCase());
}

const SPREADSHEET_EXTENSIONS = ["xlsx", "xls", "csv"];
const WORD_EXTENSIONS = ["docx", "doc"];

export function getFileTypeIcon(ext: string | null | undefined) {
  if (!ext) return <InsertDriveFileOutlined fontSize="small" color="action" />;
  const lower = ext.toLowerCase();
  if (lower === "pdf")
    return <PictureAsPdfOutlined fontSize="small" color="action" />;
  if (SPREADSHEET_EXTENSIONS.includes(lower))
    return <GridOnOutlined fontSize="small" color="action" />;
  if (WORD_EXTENSIONS.includes(lower))
    return <DescriptionOutlined fontSize="small" color="action" />;
  if ((IMAGE_EXTENSIONS as readonly string[]).includes(lower))
    return <ImageOutlined fontSize="small" color="action" />;
  return <InsertDriveFileOutlined fontSize="small" color="action" />;
}
